<template>
    <div class="py-3 position-content-main mt-4">
        <div class="page-layout blank">
            <div class="pb-2" style="min-height:fit-content">
                <div class="d-flex flex-wrap justify-content-between" style="gap:1rem">
                    <div class="breadcrumbnewtheme pb-3">
                        <div class="pre gap-0p5 fw-500 text-capitalize">
                            Work Shift
                        </div>
                        <span style="color:#b2bec3">/</span>
                        <span class="curr gap-0p5 fw-500">
                            List View
                        </span>
                    </div>
                    <div class="d-flex align-items-center justify-content-between mb-4" style="gap:.5rem">
                        <button @click="firstPage()" :disabled="skip == 0" class="mt-1 pointer pagination-list">
                            <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                                <!-- <i class="icon-chevron-double-left"></i> -->
                            <img src="/static/images/new-theme2024/arrow-left.svg" style=" z-index: 10">
                            </el-tooltip>
                        </button>
                        <button @click="previousPage()" :disabled="skip == 0" class="pagination-list-single mt-1 ml-2 pointer">
                            <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                                <!-- <i class="icon icon-chevron-left"></i> -->
                            <img src="/static/images/new-theme2024/arrow-left-single.svg" style=" z-index: 10">
                            </el-tooltip>
                        </button>
                        <span class="px-2 fw-500 fs-14 mt-1 text-black">Showing {{getSkipCount}} -
                            {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                        <button @click="nextPage()" :disabled="skip_temp >= total"
                            class="pagination-list-single mt-1 mr-2 pointer">
                            <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                                <!-- <i class="icon icon-chevron-right"></i> -->
                            <img src="/static/images/new-theme2024/arrow-right-single.svg" style=" z-index: 10">
                            </el-tooltip>
                        </button>
                        <button @click="lastPage()" class="mt-1 pointer pagination-list"
                            :disabled="temp_total == total">
                            <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                                <!-- <i class="icon-chevron-double-right"></i> -->
                            <img src="/static/images/new-theme2024/arrow-right.svg" style=" z-index: 10">

                            </el-tooltip>
                        </button>
                    </div>
                </div>
                <div class="vendor-list height-fit-content" style="background-color: #f6f8fc !important;">
                    <div class="p-0">
                        <div class="row" style="background: #f0ddb7;">
                            <div class="col-lg-4 col-md-4 col-sm-6 left-list" style="margin-right: -10px;">
                                <div class="mb-3 scroll-new view-box" style="background: white;">
                                    <div class="d-flex align-items-center justify-content-center" style="height: 100vh !important;" v-if="ajax_call_in_progress">
                                        <img class="mt-5 mb-5" src="/static/images/new-theme2024/20 card.gif" width="100" alt="digi-loader">
                                    </div>
                                    <div v-else-if="list_data.length == 0" class="d-flex text-black fw-600 align-items-center justify-content-center" style="height: 100vh !important;">
                                                No Data Found
                                            </div>
                                    <div v-else v-for="(data, index) in list_data" :key="index+'list_data'">
                                        <div class="list-box px-4 py-2 pointer"
                                            :class="{ 'list-light': index % 2, 'highlight': selected_id == data._id }"
                                            @click="getWorkShiftData(data._id)">
                                            <div class="d-flex flex-wrap justify-content-between">
                                                <span class="fs-14 font-weight-bold text-black">Work Shift: {{data.shift_name || "-"}}</span>
                                            </div>
                                            <div class="d-flex flex-wrap mt-2 justify-content-between">
                                                <span class="text-black fw-600 fs-14"
                                                    style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                                                    :title="data.template_type">
                                                    Time Shift: {{convertTime24To12(data.start_time)}} to
                                                    {{convertTime24To12(data.end_time)}}</span>
                                            </div>
                                            <div class="d-flex justify-content-between mt-2">
                                                <span class="text-black fw-500  fs-14"
                                                    style="width: 220px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis; "
                                                    :title="data.number_of_approves">Working Hours:
                                                    {{data.total_working_hours || "-"}} </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-8 col-md-8 col-sm-6 details-view-box scroll-new">
                                <div class="page-layout blank contacts-manage pt-3"
                                    style="margin-left: 0px !important;margin-right: 0px !important;">
                                    <div class="pb-10">
                                        <div class="vendor-list br-t-l-r mt-2" id="printId">
                                            <div v-if="data_loader || ajax_call_in_progress" class="d-flex align-items-center justify-content-center" style="height: 100vh !important;">
                                                <img class="mt-5 mb-5" src="/static/images/new-theme2024/20 card.gif" width="100" alt="digi-loader">
                                            </div>
                                            <div v-else-if="list_data.length == 0" class="d-flex text-black fw-600 align-items-center justify-content-center" style="height: 100vh !important;">
                                                No Data Selected
                                            </div>
                                            <div class="mb-3" v-else>
                                                <div class=" d-flex align-items-center justify-content-between  ">
                                                    <div>
                                                        <span class=" fw-600 pl-1 text-black black-border-bottom">
                                                            {{ shift_name }} Details</span>
                                                    </div>
                                                    <div>
                                                        <button class="edit-button pointer"
                                                            style="background-color: #00448b; border-radius: 4px;">
                                                            <i class="el-tooltip ri-pencil-line fs-20 text-white icon-custom-style item"
                                                                @click="showEditModal()"></i></button>
                                                        <button class="edit-button pointer ml-2"
                                                            style="background-color: #ef3c36; border-radius: 4px;"
                                                            @click="deleteWorkShiftConfirm()">
                                                            <i
                                                                class="el-tooltip icon ri-delete-bin-4-fill fs-20 text-white  icon-custom-style item"></i></button>
                                                    </div>
                                                </div>
                                                <div class="header-detail-view-new mt-5 p-3">
                                                    <div>
                                                        <span class=" pl-1 ">Details of the Shift</span>
                                                    </div>
                                                </div>
                                                <div class="row m-0 mt-3">
                                                    <div class="col-lg-12 col-md-12 col-sm-12 d-flex mb-2">
                                                        <div>
                                                            <p class="text-black pr-16 fw-500">Work Shift:</p>
                                                        </div>
                                                        <div>
                                                            <p class="text-black fw-500">{{ shift_name }}</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-12 col-md-12 col-sm-12 d-flex mb-2">
                                                        <div>
                                                            <p class="text-black pr-16 fw-500">Start Time:</p>
                                                        </div>
                                                        <div>
                                                            <p class="text-black fw-500">
                                                                <img src="/static/images/new-theme2024/time-line.svg" width="22" class="mb-1 mr-2"  />
                                                                <span >{{ start_time }}</span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-12 col-md-12 col-sm-12 d-flex mb-2">
                                                        <div>
                                                            <p class="text-black pr-18 fw-500"> End Time: </p>
                                                        </div>
                                                        <div>
                                                            <p class="text-black fw-500"> 
                                                                <img src="/static/images/new-theme2024/time-line.svg" width="22" class="mb-1 mr-2"  />
                                                                <span >{{ end_time }}</span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-12 col-md-12 col-sm-12 d-flex mb-2">
                                                        <div>
                                                            <p class="text-black pr-8 fw-500">Working Hours:</p>
                                                        </div>
                                                        <div>
                                                            <p class="text-black fw-500">
                                                                {{ total_working_hours }}</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-12 col-md-12 col-sm-12 d-flex mb-2">
                                                        <div>
                                                            <p class="text-black pr-14 fw-500">Work Week:</p>
                                                        </div>
                                                        <div>
                                                            <p class="text-black fw-500">{{ default_text }}</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-12 col-md-12 col-sm-12 d-flex mb-2">
                                                        <div>
                                                            <p class="text-black pr-20 fw-500">Days:</p>
                                                        </div>
                                                        <div>
                                                            <p class="text-black fw-500"></p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="table-content px-4 mb-3 new-popup-table pt-3 ml-2 "
                                                    style="overflow-x: auto !important;">
                                                    <table class="table table-content-data table-responsive ">
                                                        <thead>
                                                            <tr>
                                                                <th class="whiteSpace  text-capitalize border text-black fw-500">
                                                                    Monday
                                                                </th>
                                                                <th class="whiteSpace  text-capitalize border text-black fw-500">
                                                                    Tuesday
                                                                </th>
                                                                <th class="whiteSpace  text-capitalize border text-black fw-500">
                                                                    Wednesday
                                                                </th>
                                                                <th class="whiteSpace  text-capitalize border text-black fw-500">
                                                                    Thursday
                                                                </th>
                                                                <th class="whiteSpace  text-capitalize border text-black fw-500">
                                                                    Friday
                                                                </th>
                                                                <th class="whiteSpace  text-capitalize border text-black fw-500">
                                                                    Saturday
                                                                </th>
                                                                <th class="whiteSpace  text-capitalize border text-black fw-500">
                                                                    Sunday
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td class="whiteSpace  text-center border">
                                                                    <el-checkbox v-model="monday" disabled>
                                                                    </el-checkbox>
                                                                </td>
                                                                <td class="whiteSpace  text-center border">
                                                                    <el-checkbox v-model="tuesday" disabled>
                                                                    </el-checkbox>
                                                                </td>
                                                                <td class="whiteSpace  text-center border">
                                                                    <el-checkbox v-model="wednesday" disabled>
                                                                    </el-checkbox>
                                                                </td>
                                                                <td class="whiteSpace  text-center border">
                                                                    <el-checkbox v-model="thursday" disabled>
                                                                    </el-checkbox>
                                                                </td>
                                                                <td class="whiteSpace  text-center border">
                                                                    <el-checkbox v-model="friday" disabled>
                                                                    </el-checkbox>
                                                                </td>
                                                                <td class="whiteSpace  text-center border">
                                                                    <el-checkbox v-model="saturday" disabled>
                                                                    </el-checkbox>
                                                                </td>
                                                                <td class="whiteSpace  text-center border">
                                                                    <el-checkbox v-model="sunday" disabled>
                                                                    </el-checkbox>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div v-if="create_modal" class="filters-background filterblock"> -->
        <create-configure-shift-work v-if="create_modal"  @saveSuccess="saveSuccess" @hideModal="hideCreateModal"
            :workshift_id="selected_id" :mode="mode" modal_name="Create-Modal"></create-configure-shift-work>
            <!-- </div> -->
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
    const CreateConfigureShiftWork = () => import('./CreateConfigureShiftWork');
    import {
        HollowDotsSpinner
    } from "epic-spinners";
    import facility_mgmt from '../../mixins/facility_mgmt.js';
    import {
        SweetModal
    } from 'sweet-modal-vue';
    import {
        EventBus
    } from '../../eventBus/nav-bar-event.js';
    import time_utils from '../../mixins/time_utils.js';
    import Swal from 'sweetalert2';
    export default {
        mixins: [facility_mgmt, time_utils],
        props: ["ajaxCallInProgress"],

        components: {
            CreateConfigureShiftWork,
            SweetModal,
            Swal,
            HollowDotsSpinner
        },
        data() {
            return {
                delete_loader: false,
                success_msg: '',
                warning_msg: '',
                create_modal: false,
                list_data: [],
                ajax_call_in_progress:false,
                mode: 'create',
                skip: 0,
                limit: 10,
                total: 0,
                temp_total: 0,
                search_key: '',
                pageLimit: [],
                skip_temp: 0,
                count: 0,
                pageLimit: [],
                monday: false,
                tuesday: false,
                wednesday: false,
                data_loader: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
                selected_id: '',
                days_of_workshift: [],
                default_text: '',
                end_time: '',
                start_time: '',
                shift_name: '',
                total_working_hours: '',
            }
        },
        methods: {
            hideCreateModal() {
                EventBus.$emit('ZindexChangeEnd')
                this.create_modal = false;
                setTimeout(() => {
                    this.$modal.hide('Create-Modal');
                }, 500);
            },
            showCreateModal() {
                EventBus.$emit('ZindexChangeStart')
                this.mode = 'create';
                this.create_modal = true;
                setTimeout(() => {
                    this.$modal.show('Create-Modal');
                }, 500);
            },
            showEditModal() {
                EventBus.$emit('ZindexChangeStart')
                this.mode = 'edit';
                this.create_modal = true;
                setTimeout(() => {
                    this.$modal.show('Create-Modal');
                }, 500);
            },
            firstPage() {
                this.temp_total = 0
                this.skip = 0
                this.limit = 10
                this.list_data = []
                this.getListData()
            },
            lastPage() {
                this.skip_temp = 0
                this.skip = 0
                this.temp_total = this.total
                let no_of_pages = Math.ceil(this.total / this.limit)
                this.skip_temp = (no_of_pages * this.limit) - this.limit
                if (this.skip_temp >= this.total) {
                    return;
                }
                this.skip = this.skip_temp
                this.getListData();
            },
            nextPage() {
                this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
                if (this.skip_temp >= this.total) {
                    return;
                }
                this.skip = this.skip_temp;
                this.getListData();
            },
            previousPage() {
                this.skip_temp = 0
                this.temp_total = 0
                if (this.skip == 0) {
                    return;
                }
                this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
                this.getListData();
            },
            async getWorkShiftData(id) {
                this.selected_id = id
                this.data_loader = true
                try {
                    let params = {
                        workshift_id: this.selected_id
                    };
                    let response = await this.getWorkShiftById(params);
                    this.days_of_workshift = response.response.days_of_workshift;
                    console.log(this.days_of_workshift)
                    this.default_text = response.response.default;
                    this.end_time = this.convertTime24To12(response.response.end_time);
                    this.start_time = this.convertTime24To12(response.response.start_time);
                    // this.end_date = response.response.end_date.replace(/-/g, '/');
                    // this.start_date = response.response.start_date.replace(/-/g, '/');
                    this.shift_name = response.response.shift_name;
                    this.total_working_hours = response.response.total_working_hours;
                    this.monday = false;
                    this.tuesday = false;
                    this.wednesday = false;
                    this.thursday = false;
                    this.friday = false;
                    this.saturday = false;
                    this.sunday = false;
                    this.days_of_workshift.forEach((el, index) => {
                        switch (el) {
                            case 'Mon':
                                this.monday = true;
                                break;
                            case 'Tue':
                                this.tuesday = true;
                                break;
                            case 'Wed':
                                this.wednesday = true;
                                break;
                            case 'Thur':
                                this.thursday = true;
                                break;
                            case 'Fri':
                                this.friday = true;
                                break;
                            case 'Sat':
                                this.saturday = true;
                                break;
                            case 'Sun':
                                this.sunday = true;
                                break;
                        }
                    });
                    this.data_loader = false
                } catch (error) {
                    this.data_loader = false
                    this.warning_msg = error;
                    this.$refs.warning_modal.open();
                }
            },
            async getListData() {
                this.list_data = [];
                this.ajax_call_in_progress = true;
                try {
                    let params = {
                        skip: this.skip,
                        limit: this.limit,
                        search_key: this.search_key.trim(),
                    };
                    let response = await this.getWorkShiftList(params);
                    this.list_data = response.response.workshifts;
                    if(this.list_data.length != 0){
                    this.selected_id = this.list_data[0]._id;
                    this.getWorkShiftData(this.selected_id);
                    }
                    this.total = response.response.count;
                    this.$emit('work_data_length', this.total);
                    this.ajax_call_in_progress = false;
                } catch (error) {
                    console.log(error)
                    this.warning_msg = error;
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                    this.ajax_call_in_progress = false;
                }
            },
            deleteWorkShiftConfirm(id) {
                Swal.fire({
                    title: 'Alert',
                    text: "Are you sure want to delete ?",
                    type: 'warning',
                    icon: 'warning',
                    showCloseButton: true,
                    showCancelButton: true,
                    confirmButtonColor: '#00448b',
                    confirmButtonText: 'YES',
                    cancelButtonText: 'NO'
                }).then((result) => {
                    if (result.isConfirmed == true) {
                        this.deleteWorkShift(id)
                    }
                })
            },
            async deleteWorkShift() {
                this.delete_loader = true
                try {
                    let params = {
                        workshift_id: this.selected_id,
                    }
                    let response = await this.deleteWorkShiftById(params);
                    this.success_msg = response.response.success_message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.$refs.success_modal.close();
                        this.delete_loader = false
                        this.getListData();
                    }, 3000);
                } catch (error) {
                    this.delete_loader = false
                    this.warning_msg = error;
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            },
            saveSuccess() {
                this.getListData();
            }
        },
        mounted() {
            for (let i = 10; i <= 50; i += 10) {
                this.pageLimit.push(i);
            }
            this.getListData();
            EventBus.$on('addWorkShift', () => {
                this.showCreateModal();
            });
        },
        watch: {
            limit: function () {
                this.getListData();
            }
        },
        computed: {
            getSkipCount() {
                if (this.total == 0) {
                    return 0
                } else {
                    let skip_count = this.skip > this.total ? this.total : this.skip + 1;
                    return skip_count;
                }
            },
        }
    }
</script>
<style scoped>
    .table-content-data tr th {
        text-transform: capitalize;
        color: #00448b;
        background-color: white !important;
    }

    .border {
        border: solid 0.1px #130e0e !important;
    }
    .btn-new-call {
        background-color: #03855d !important;
        color: white;
        border-radius: 5px;
    }
    .list-light {
        width: 100%;
        object-fit: contain;
        border-radius: 5px;
        box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
        border: solid 0.5px #f3f6fb;
        background-color: #ffffff;
    }
    .highlight {
        background-color: #d5e2fa !important;
    }

    @media (max-width: 1100px) {
        .hide-line {
            display: none;
        }
    }

    .edit-button {
        background-color: #fff;
        height: 32px !important;
        width: 40px;
        line-height: 39px !important;
        border-radius: 4px;
    }

    .box-blue-header {
        border-radius: 3px;
    }

    .box-blue-header-parent {
        background: #005dae;
        position: relative;
        top: -1px;
        margin-left: -1px;
    }

    .ticket_count {
        background-color: #7b7f97;
        border-radius: 20px;
        font-size: 10px;
        font-weight: 600 !important;
        color: #ffffff;
        margin-left: 4px;
        padding: 0px 6px;
    }

    .count-ticket {
        background-color: #1b57ad;
        border-radius: 20px;
        font-size: 10px;
        font-weight: 600 !important;
        color: #ffffff;
        margin-left: 4px;
        padding: 0px 6px;
    }

    .ticket_tab {
        background-color: #005dae;
    }

    .activeColor {
        background-color: #005dae;
        color: #ffffff;
    }

    .email-buttons {
        display: none;
    }

    @media screen and (max-width: 991px) {
        .mob-list-scroll {
            min-width: 991px;
        }
    }

    .btn-success {
        background-color: #25bb83 !important;
    }

    .ticket-list-button {
        color: #363636;
        border-radius: 6px !important;
        box-shadow: none !important;
        font-weight: 600;
        background-color: #e4e4e4;
        width: 230px;
    }
    .scm-filters {
        font-family: "Poppins", "Helvetica Neue", sans-serif !important;
        height: 500px;
        overflow: auto;
        max-width: 768px;
        top: 100px;
        background: #e6ecff !important;
    }

    .overflow-visible {
        overflow: scroll !important;
    }
    .col-small-left {
        width: 200px;
    }

    .col-small-right {
        position: relative;
        width: 700px;
    }

    .left-list {
        height: max-content !important;
    }

    @media (max-width: 900px) {
        .scroll-news {
            min-width: 900px;
            overflow-x: scroll !important;
        }
    }

    @media (max-width: 580px) {
        .vendor-list {
            height: 100% !important;
        }
    }

    .hor-line {
        width: 2px;
        height: 30px;
        background-color: #1b57ad;
    }

    .filter-box {
        width: 200px;
        height: 30px;
        padding: 2px 3.3px 1.5px 6.5px;
        border: solid 0.5px #363636;
        background-color: #fff;
    }

    .width-fit-content {
        width: fit-content
    }

    .fs-18 {
        font-size: 18px;
    }

    .whitespace-nowrap {
        white-space: nowrap;
    }

    .dropbtn {
        background-color: #fff;
        cursor: pointer;
        margin-top: -5px;
        border-radius: 5px;
        line-height: 33px;
    }

    .res-width {
        min-width: 60%
    }

    .ticket_list_number-selected {
        background-color: #00448b !important;
        color: #fff !important;
    }

    .ticket_list_number-selected .li_span {
        color: #fff !important
    }

    .ticket_list_number-selected i {
        color: #fff !important;
        border: 1px solid #fff !important;
    }

    .ticket_list_number-selected i.no-border {
        border: none !important;
    }

    @media screen and (max-width:1347px) {
        .res-width {
            min-width: 75%
        }
    }

    @media screen and (max-width:1011px) {
        .res-width {
            min-width: 100%;
            flex-wrap: wrap
        }
    }


    .dropdown {
        position: relative;
        display: inline-block;
    }

    .dropdown-content {
        display: none;
        position: absolute;
        background-color: #fff;
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
        border-radius: 5px;
        z-index: 1;
        right: 0px;
        top: 32px;
    }

    .dropdown-content a {
        color: black;
        padding: 12px 16px;
        text-decoration: none;
        display: block;
    }

    .dropdown-content a:not([href]):not([tabindex]).tabbed {
        width: 100%;
        vertical-align: middle;
    }

    .dropdown-content a:not([href]):not([tabindex]).tabbed:hover {
        background-color: #eee;
    }

    .dropdown:hover .dropdown-content {
        display: block;
    }

    .height-fit-content {
        height: fit-content
    }
    .search_input {
        padding: 8px 9.4px 6.5px 33.4px;
        border-radius: 24px;
        background-color: #fff;
        border: 1px solid rgba(103, 103, 103, 0.84);
        border-radius: 18px;
    }

    .align-position {
        position: absolute;
        left: 10px;
        top: 7px;
        color: rgba(103, 103, 103, 0.84);
    }

    .search-bar {
        margin: 0 30px 0 30px;
    }

    .add-btn {
        margin-right: 24px;
        height: 34px;
    }

    .ht-100px {
        height: 100px;
    }

    .w-15 {
        width: 15% !important
    }

    .w-1 {
        width: 1% !important;
        min-width: 250px !important
    }

    .table-content-data tr th {
        text-transform: capitalize;
        color: #00448b;
        background-color: #e8e9ec;
    }

    .text-white {
        color: #fff !important;
    }

    .text-green {
        color: #038b62 !important;
    }

    .breadcrumbnewtheme {
        display: flex;
        align-items: center;
        gap: 1rem;
    }

    .breadcrumbnewtheme div {
        color: #00448b;
    }
    .fs-2rem {
        font-size: 2rem;
    }
    .header-color {
        color: #4e4e4e !important;
    }
</style>